/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module alignment
 */

export { default as Alignment } from './alignment';
export { default as AlignmentEditing } from './alignmentediting';
export { default as AlignmentUI } from './alignmentui';
